const getPercentageValue = (value: number, total: number) => {
  if (total === 0) return 0
  return Math.round(Number(((value / total) * 100).toFixed(2)))
}

export default getPercentageValue
